console.log('location');

// ______________________________________
// 六本松421
document.addEventListener('DOMContentLoaded', function () {
    const sec2 = document.querySelector('.sec2');
    if (!sec2) return;

    const stage = sec2.querySelector('.sec2Stage');
    const imgBox = sec2.querySelector('.sec2Img');
    const overlay = sec2.querySelector('.sec2Img__overlay');
    const shop = sec2.querySelector('.shop');

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function lerp(start, end, t) {
        return start + (end - start) * t;
    }

    function updateSec2Animation() {
        const rect = stage.getBoundingClientRect();
        const vh = window.innerHeight;

        const totalScroll = rect.height - vh;
        const currentScroll = clamp(-rect.top, 0, totalScroll);
        const progress = totalScroll > 0 ? currentScroll / totalScroll : 0;

        const scaleProgress = clamp(progress / 0.55, 0, 1);
        const scale = lerp(1, 2.4, scaleProgress);

        const effectProgress = clamp((progress - 0.28) / 0.42, 0, 1);
        const overlayAlpha = lerp(0, 0.45, effectProgress);
        const blurValue = lerp(0, 4, effectProgress);

        const shopProgress = clamp((progress - 0.48) / 0.24, 0, 1);

        imgBox.style.transform = `translate(-50%, -50%) scale(${scale})`;
        overlay.style.background = `rgba(0, 0, 0, ${overlayAlpha})`;
        overlay.style.backdropFilter = `blur(${blurValue}px)`;
        overlay.style.webkitBackdropFilter = `blur(${blurValue}px)`;

        shop.style.opacity = shopProgress;
        shop.style.pointerEvents = shopProgress > 0.1 ? 'auto' : 'none';
    }

    window.addEventListener('scroll', updateSec2Animation, { passive: true });
    window.addEventListener('resize', updateSec2Animation);
    updateSec2Animation();
});

// ______________________________________
// カルーセル
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Splide === 'undefined') return;

    const carousels = document.querySelectorAll('.carousel');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
        const bar = carousel.querySelector('.carousel__progress-bar');
        const prev = carousel.querySelector('.carousel__arrow--prev');
        const next = carousel.querySelector('.carousel__arrow--next');

        const splide = new Splide(carousel, {
            type: 'loop',
            autoWidth: true,
            focus: 'center',
            gap: '3vw',
            pagination: false,
            arrows: false,
            trimSpace: false,
            autoplay: true,
            interval: 4000,
            pauseOnHover: false,
            pauseOnFocus: false,
            speed: 800
        });

        const updateBar = () => {
            if (!bar) return;

            const total = splide.length;
            if (!total) return;

            const current = splide.index % total;
            const unit = 100 / total;

            bar.style.width = `${unit}%`;
            bar.style.transform = `translateX(${current * 100}%)`;
        };

        splide.on('mounted move updated refresh resized', updateBar);

        prev?.addEventListener('click', () => splide.go('<'));
        next?.addEventListener('click', () => splide.go('>'));

        splide.mount();
    });
});

// ______________________________________
// ライフインフォ
document.addEventListener("DOMContentLoaded", () => {
    const lifes = document.querySelectorAll('.lifeInfo .lifeBtn li');
    const infoBox = document.querySelectorAll('.lifeInfo .infoList');
    const mapBox = document.querySelectorAll('.lifeInfo .mapBox .mapImg');

    const spWidth = 768;

    function isSP() {
        return window.innerWidth <= spWidth;
    }

    function setMap(index) {
        const targetMap = mapBox[index];
        if (!targetMap) return;

        const iframe = targetMap.querySelector('iframe');
        if (!iframe) return;

        const url = isSP() ? targetMap.dataset.sp : targetMap.dataset.pc;

        if (iframe.getAttribute('src') !== url) {
            iframe.setAttribute('src', url);
        }
    }

    lifes.forEach((life, index) => {
        life.addEventListener('click', () => {
            lifes.forEach(item => item.classList.remove('active'));
            infoBox.forEach(info => info.classList.remove('active'));
            mapBox.forEach(map => map.classList.remove('active'));

            life.classList.add('active');
            if (infoBox[index]) infoBox[index].classList.add('active');
            if (mapBox[index]) mapBox[index].classList.add('active');

            setMap(index);
        });
    });

    // 初期表示の地図だけ読み込み
    const activeIndex = [...mapBox].findIndex(map => map.classList.contains('active'));
    setMap(activeIndex >= 0 ? activeIndex : 0);

    // PC/SPをまたいでリサイズした時だけURLを切り替える
    let currentMode = isSP() ? 'sp' : 'pc';
    let resizeTimer;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
            const newMode = isSP() ? 'sp' : 'pc';

            if (currentMode === newMode) return;
            currentMode = newMode;

            const activeIndex = [...mapBox].findIndex(map =>
                map.classList.contains('active')
            );

            if (activeIndex >= 0) {
                setMap(activeIndex);
            }
        }, 300);
    });
});

// ______________________________________
document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger);

    const itemImg = document.querySelectorAll('.gou_Img img');
    const secImg = document.querySelectorAll('.sec_img img');

    itemImg.forEach(item => {
        gsap.set(item, {
            y: 30,
        })

        gsap.to(item, {
            y: -30,
            scrollTrigger: {
                trigger: item,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        })
    })

    secImg.forEach(sec => {
        gsap.set(sec, {
            y: 30,
        })

        gsap.to(sec, {
            y: -30,
            scrollTrigger: {
                trigger: sec,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        })
    })
});